import {
  ApiGetRequest,
  ApiBlobGetRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Report - MonthlyCashier',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - MonthlyCashier',
        href: '/adm/opr/report/monthly-cashier',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'created_at',
    sortDesc: true,
    export: 0,
    fields: [
      {
        key: 'trans_principle',
        label: 'Principle',
      },
      {
        key: 'created_at',
        label: 'Time',
      },
      {
        key: 'trans_doc',
        label: 'D/O No',
      },
      {
        key: 'trans_use_by',
        label: 'Use By',
      },
      {
        key: 'trans_code',
        label: 'Document No',
      },
      {
        key: 'trans_party',
        label: 'Party',
      },
      {
        key: 'total_idr',
        label: 'IDR',
      },
      {
        key: 'total_usd',
        label: 'USD',
      },
    ],
    detail: false,
    total_idr: 0,
    total_usd: 0,
    form: {
      id_user: '',
      name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportMonthlyCashier(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportMonthlyCashier({ commit, state }) {
    commit('reportMonthlyCashier', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: data.form.date ? moment(data.form.date).format('YYYY-MM-DD') : '',
    };

    let result = await ApiGetRequest(`opr/report/monthly-cashier`, params);
    commit('reportMonthlyCashier', {
      items: result.data.object || null,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportMonthlyCashier({ commit, state }) {
    commit('reportMonthlyCashier', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: data.form.date ? moment(data.form.date).format('YYYY-MM-DD') : '',
      export: 1,
    };

    let result = await ApiBlobGetRequest(`opr/report/monthly-cashier`, params);
    commit('reportMonthlyCashier', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_cashier.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },
};
